import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Books from '../views/Books.vue'
import notFound from '../views/404.vue'
import i18n from '../i18n' // Assuming your i18n instance is exported from this path
import faq from '../views/FAQ.vue'
import terms from '../views/terms.vue'
import privacy from '../views/privacy.vue'
import more from '../views/more.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: notFound,
  },
  {
    path: '/faq',
    name: 'faq',
    component: faq,
  },
  {
    path: '/terms',
    name: 'terms',
    component: terms,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy,
  },
  {
    path: '/faq',
    name: 'faq',
    component: faq,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/books/:id',
    name: 'books',
    component: Books
  },
  {
    path: '/more',
    name: 'more',
    component: more
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // Add scrollBehavior to handle anchor links
  scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  }

  // If there is a hash AND we are coming from a different route
  if (to.hash && from.path !== to.path) {
    return new Promise((resolve) => {
      // Step 1: Scroll to top immediately
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

      // Step 2: Then scroll to the hash after a small delay (static site needs this)
      setTimeout(() => {
        const element = document.querySelector(to.hash);
        if (element) {
          const navbarHeight = document.querySelector('nav')?.offsetHeight || 0;
          const offset = navbarHeight + 30; // extra space

          const topPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({
            top: topPosition,
            behavior: 'smooth'
          });
        }
        resolve(false); // prevent default router scroll
      }, 100);
    });
  }

  // Normal case: no hash → scroll to top
  if (!to.hash) {
    return { left: 0, top: 0 };
  }

  // Fallback for same-page hash clicks (your original behavior)
  return {
    selector: to.hash,
    behavior: 'smooth'
  };
}
})

// Add a navigation guard to handle locale from route parameters
router.beforeEach((to, from, next) => {
  // Check if a locale parameter is present in the route object
  // and if it's different from the current i18n locale
  if (to.params.locale && i18n.locale !== to.params.locale) {
    i18n.locale = to.params.locale;
  }
  // Make sure a default locale is set if none is provided via params
  // This helps when navigating directly to '/' without a locale param
  if (!i18n.locale) {
    i18n.locale = 'en'; // Or your application's default locale
  }
  next(); // Continue to the next route
});

export default router
